import ConditionalRedirect from 'app/components/router/ConditionalRedirect';
import { WrongBrandRoute } from 'app/constants/Routes';
import IRoute from 'app/constants/Routes/IRoute';
import { User } from 'app/constants/schemas/User';
import React from 'react';
import { useBrand } from '../OrganizationContext';
import { useAuthUser } from './AuthUserContext';

export interface IProps {
  authUser: User | null;
  excludeRoutes: IRoute[];
  children: React.ReactNode;
}

export const WrongBrandRedirect: React.SFC<IProps> = ({
  children,
  authUser,
  excludeRoutes,
}) => {
  const siteBrand = useBrand();
  return (
    <ConditionalRedirect
      to={WrongBrandRoute.getPathname()}
      when={
        authUser !== null &&
        authUser.brand !== siteBrand.id &&
        authUser.staffMember === null &&
        authUser.teacher === null
      }
      excludeRoutes={excludeRoutes}
    >
      {children}
    </ConditionalRedirect>
  );
};

function WrongBrandRedirectInjectDependencies(props: Omit<IProps, 'authUser'>) {
  const authUser = useAuthUser();
  return <WrongBrandRedirect {...props} authUser={authUser} />;
}

export default WrongBrandRedirectInjectDependencies;
